import { MODULES } from '@/constants'

export default [
  {
    path: '/payment',
    meta: {
      requiresAuth: true,
      permission: MODULES.PAYMENT
    },
    component: () => import(/* webpackChunkName: "home" */ `@/views/Payment.vue`),
    children: [
      {
        path: '/',
        name: 'payment.index',
        meta: {
          title: 'general.payment'
        },
        component: () => import(/* webpackChunkName: "home" */ `@/views/Payment/Index.vue`)
      },
      {
        path: 'status',
        name: 'payment.status',
        meta: {
          title: 'general.payment'
        },
        component: () => import(/* webpackChunkName: "home" */ `@/views/Payment/Status.vue`)
      }
    ]
  }
]
